export const RED_ADDITION = '#e84249';
export const CIEL_ADDITION = '#5ac8f5';
export const BLUE_ADDITION = '#262957';
export const GREEN_TERRASSE = '#7cc4ac';
